/**
 * @file customerAssignment.ts
 * @module api/apiJSON/customerAssignment
 * @description Defines customerAssignment API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { IListCustomerAssignment, IAssignCustomerRep } from "../../types";

export const customerAssignmentJson = {
  list: (data: IListCustomerAssignment) => {
    let params: any = {
      pageNo: data.pageNo,
      limit: data.limit,
      searchTerm: data.searchTerm ? data.searchTerm : "",
      needCount: true,
    };
    if (data.repId) {
      params.repId = data.repId;
    }
    if (data.districtId) {
      params.districtId = data.districtId;
    }
    if (data.lastOrderDays) {
      params.lastOrderDays = data.lastOrderDays;
    }
    return params;
  },
  assign: (data: IAssignCustomerRep) => {
    return {
      user: data.users,
      assignedTo: data.assignedTo,
    };
  },
};
